import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import LatestTranaction from "./LatestTranaction";
import { getAllEvents, getAllOrganizer, getAllCountries, getAllUsers, getArtists } from "api";
import { getAuthUser, getCountryId, getUserRole } from "utils/storage";
import { useSelector } from "react-redux";

import useCountryStore from "../../store/countryStore";

import EventList from "pages/Admin/Events/EventList";
import OrganizerList from "pages/Admin/Organizers/OrganizerList";
import RevenueReport from "pages/Admin/Report/EventoxRevenue";
import ArtistList from "pages/Admin/Artists/ArtistList";
import AppUsers from "./AppUsers";

const Dashboard = props => {
  const { selectedCountryId } = useCountryStore();
  const [eventList, setEventList] = useState([])
  const [organizerList, setOrganizerList] = useState([])
  const role = getUserRole();
  const [activeTab, setActiveTab] = useState(null);

  useEffect(() => {
    if (activeTab === "Events") {
      document.title = "EventList | EventoX";
    } else if (activeTab === "Organizers") {
      document.title = "Organizer List | EventoX";
    } else if (activeTab === "Users") {
      document.title = "App Users | EventoX";
    } else if (activeTab === "Artists") {
      document.title = "Artist Management | EventoX";
    } else if (activeTab === "Revenue") {
      document.title = "Revenue Report | EventoX";
    } else {
      document.title = "Dashboard | EventoX";
    }
  }, [activeTab]);

  const [reports, setReports] = useState([
    { title: "Events", iconClass: "bx-copy-alt", description: 0 },
    { title: "Organizers", iconClass: "bx-archive-in", description: 0 },
    {
      title: "Revenue",
      iconClass: "bx-purchase-tag-alt",
      description: 0,
    },
    {
      title: "Users",
      iconClass: "bx-user",
      description: 0,
    },
    {
      title: "Artists",
      iconClass: "bx-music",
      description: 0,
    },
  ])

  useEffect(() => {
    fetchAll()
  }, [selectedCountryId])

  const fetchAll=async()=>{
    try {
      const respAllEvent = await getAllEvents();

      let orgRes = await getAllOrganizer();
      setOrganizerList(orgRes)
      setEventList(respAllEvent)

      let usersCount = 0;
      let artistsCount = 0;
      try {
        const usersRes = await getAllUsers();
        const appUsersList = Array.isArray(usersRes) ? usersRes.filter(user => Number(user.userRole) === 6) : [];
        usersCount = appUsersList.length;
      } catch (err) {
        console.error("Error fetching users count:", err);
      }
      try {
        const artistsRes = await getArtists();
        artistsCount = artistsRes?.length || 0;
      } catch (err) {
        console.error("Error fetching artists count:", err);
      }

      setReports([
        { title: "Events", iconClass: "bx-copy-alt", description: respAllEvent?.length || 0 },
        { title: "Organizers", iconClass: "bx-archive-in", description: orgRes?.length || 0 },
        {
          title: "Revenue",
          iconClass: "bx-purchase-tag-alt",
          description: 0,
        },
        {
          title: "Users",
          iconClass: "bx-user",
          description: usersCount,
        },
        {
          title: "Artists",
          iconClass: "bx-music",
          description: artistsCount,
        },
      ])
    } catch (error) {
      console.log(error);
    }
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("Dashboards")}
            breadcrumbItem={props.t("Dashboard")}
          />

          <Row>
           <Col xl="12">
            <Row>
                 {(reports || [])?.map((report, key) => (
                   <Col md="4" key={"_col_" + key}>
                     <Card 
                       className={`mini-stats-wid ${activeTab === report.title ? 'border border-primary' : ''}`}
                       style={{ 
                         cursor: 'pointer', 
                         transition: 'border-color 0.2s, box-shadow 0.2s', 
                         border: activeTab === report.title ? '1.5px solid #556ee6' : '1px solid transparent',
                         boxShadow: activeTab === report.title ? '0 0.5rem 1rem rgba(85, 110, 230, 0.15)' : ''
                       }}
                       onClick={() => {
                         setActiveTab(prev => prev === report.title ? null : report.title);
                       }}
                     >
                       <CardBody>
                         <div className="d-flex">
                           <div className="flex-grow-1">
                             <p className="text-muted fw-medium">
                               {report.title}
                             </p>
                             <h4 className="mb-0">{report.description}</h4>
                           </div>
                           <div className="avatar-sm rounded-circle bg-primary align-self-center mini-stat-icon">
                             <span className="avatar-title rounded-circle bg-primary">
                               <i className={"bx " + report.iconClass + " font-size-24"}></i>
                             </span>
                           </div>
                         </div>
                       </CardBody>
                     </Card>
                   </Col>
                 ))}
               </Row>
           </Col>
           </Row>
           <Row>
            <Col lg="12">
              {activeTab === "Events" && <EventList isDashboard={true} />}
              {activeTab === "Organizers" && <OrganizerList isDashboard={true} />}
              {activeTab === "Revenue" && <RevenueReport isDashboard={true} />}
              {activeTab === "Users" && <AppUsers />}
              {activeTab === "Artists" && <ArtistList isDashboard={true} />}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
};

export default withTranslation()(Dashboard);
